import { render, staticRenderFns } from "./AmbassadorData.vue?vue&type=template&id=1fe9f8d2&"
import script from "./AmbassadorData.vue?vue&type=script&lang=js&"
export * from "./AmbassadorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports